import {mappingUuidRegion} from '@common/constants/documents/RegionConstants';
import {DocumentsInfo} from '@common/types/stores/productSheetStore.types';
import {ClaimItem, ClaimItems, PreflightReportsType} from '@common/types/documents/globalMarketingContent.types';
import DocumentStatusConstants from '@common/constants/documents/DocumentStatusConstants';
import {CLAIM_SCORING_STATUS} from '@common/constants/documents/documentStatus';

export const getPreflightReportsWithRules = (preflightReports: PreflightReportsType[] = []) => {
  return preflightReports.filter(item => item.rules && Array.isArray(item.rules));
};

export const enhanceRegionUuid = (regionUuid: string): DocumentsInfo => ({id: regionUuid, name: mappingUuidRegion[regionUuid] || ''});

export const mapClaimDataByUuid = (data: ClaimItems): ClaimItem[] => Object.keys(data).map(uuid => data[uuid]);

export const getClaimStatus = (documentStatus?: string) => {
  switch (documentStatus) {
    case DocumentStatusConstants.DRAFT:
      return CLAIM_SCORING_STATUS.UNAVAILABLE;
    case DocumentStatusConstants.READY:
      return CLAIM_SCORING_STATUS.AVAILABLE;
    default:
      return CLAIM_SCORING_STATUS.PENDING;
  }
};
